import classes from './Grid.module.css'

const Grid = ({children, columns, margin, gap, special}) => {
    return <div className={`${classes.grid} ${columns ? classes['grid_' + columns] : ''} ${special ? classes['grid_' + special] : ''} ${gap ? classes['grid_gap_' + gap] : ''} ${margin ? classes['margin_' + margin] : ''}`}>{children}</div>
}

export default Grid